import { RealityCheckDto } from "@data-types/reality-check/RealityCheckDto";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

export class RealityCheckApiService {
	static baseUrl(context: ApiRequestContextData | null) {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/reality-checks`;
	}
	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getRealityCheckData(
		options: ContextOptions
	): Promise<RealityCheckDto> {
		const context = getApiRequestContext(options);
		let url = this.baseUrl(context);
		if (WEBPACK_IS_CASINO_ENABLED && WEBPACK_IS_CASINO_LIVE_ENABLED) {
			url += "?isCasinoEnabled=true&isLiveCasinoEnabled=true";
		} else if (WEBPACK_IS_CASINO_ENABLED) {
			url += "?isCasinoEnabled=true";
		} else if (WEBPACK_IS_CASINO_LIVE_ENABLED) {
			url += "?isLiveCasinoEnabled=true";
		}

		return await httpClient.get(url, this.getRequestHeaders(context));
	}
}
